
import { defineComponent } from 'vue'
import { iFunctionType } from './FunctionsCatalog'
import Card from 'primevue/card'
import functionsCatalogFilterCardDescriptor from './FunctionsCatalogFilterCardDescriptor.json'

export default defineComponent({
    name: 'functions-catalog-filter-card',
    components: { Card },
    props: { propFilter: { type: Object } },
    emits: ['selected'],
    data() {
        return {
            functionsCatalogFilterCardDescriptor,
            filter: {} as iFunctionType
        }
    },
    watch: {
        propFilter: {
            handler() {
                this.loadFilter()
            },
            deep: true
        }
    },
    created() {
        this.loadFilter()
    },
    methods: {
        loadFilter() {
            this.filter = { ...this.propFilter } as iFunctionType
            this.filter.valueDescription = this.functionsCatalogFilterCardDescriptor.filterImagesMap[this.filter.valueDescription]
        }
    }
})
